import { useTranslation } from 'react-i18next'

function Banners() {
  const { t } = useTranslation()

  return (
    <section className="tc-banners-style6">
      <div className="container">
        <div className="banners">
          <div className="row">
            <div className="col-lg-6">
              <a href="#0" className="banner-card wow zoomIn slow" data-wow-delay="0.2s">
                <div className="img">
                  <img src="/assets/images/branding/banners/banner1.png" alt="" className="img-cover" />
                </div>
                <div className="info">
                  <div className="cont">
                    <div className="text fsz-16 mb-50 marcellus">
                      {t('banners.handcrafted.description')}
                    </div>
                    <h3 className="marcellus">{t('banners.handcrafted.title')}</h3>
                  </div>
                </div>
              </a>
            </div>
            <div className="col-lg-6">
              <a href="#0" className="banner-card wow zoomIn slow" data-wow-delay="0.4s">
                <div className="img">
                  <img src="/assets/images/branding/banners/banner2.jpg" alt="" className="img-cover" />
                </div>
                <div className="info">
                  <div className="cont">
                    <div className="text fsz-16 mb-50 marcellus">
                      {t('banners.quality.description')}
                    </div>
                    <h3 className="marcellus">{t('banners.quality.title')}</h3>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Banners
